import React, { Component } from 'react';
import { TableCell } from '@mui/material';
import { fCurrency } from '../../utils/formatNumber';


export default class GridAmountCell extends Component {
    //props: value, id, field
    render() {
        const value = this.props.value || 0;
        const formattedAmount = fCurrency(value);
        return (
            <TableCell key={this.props.field.id} align="left">
                {formattedAmount}
            </TableCell>
        );
    }
}
